import { render, staticRenderFns } from "./spin-loader.vue?vue&type=template&id=40750c8a&scoped=true&"
import script from "./spin-loader.vue?vue&type=script&lang=js&"
export * from "./spin-loader.vue?vue&type=script&lang=js&"
import style0 from "./spin-loader.vue?vue&type=style&index=0&id=40750c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40750c8a",
  null
  
)

export default component.exports